import Vue from 'vue'
import VueFbCustomerChat from 'vue-fb-customer-chat'

Vue.use(VueFbCustomerChat, {
  page_id: '111477060422887',
  theme_color: '#4570FB',
  locale: 'zh_TW',
  logged_out_greeting: 'Hi! 我們有什麼能幫助你的嗎？',
  logged_in_greeting: 'Hi! 我們有什麼能幫助你的嗎？'
})



// WEBPACK FOOTER //
// ./src/utils/vueFbCustomerChat.js